import { AxiosResponse } from "axios";
import { call, put, takeEvery } from "redux-saga/effects";

import {
  getUrlParameter,
} from "../../utils/actions";

import { invokeAPI } from "../sagas";
import {
  ScreenDataUpdateAction,
  UsernameAction,
  TeacherUsernameAction,
  BackgroundCategoryGetAction,
  BackgroundListGetAction,
  UserBackgroundListGetAction,
  BoardInfoGetAction,
  BoardLastPageAction,
  BoardListGetAction,
  BoardPageCreateAction,
  BoardPageUpdateAction,
  BoardPageDeleteAction,
  BoardPageCopyAction,
  ImageListGetAction,
  BoardElementListGetAction,
  BoardElementDeleteAction,
  BoardElementGroupDeleteAction,
  MemberCreateAction,
  MemberListGetAction,
  CardCreateAction,
  CardListGetAction,
  WorkListGetAction,
  BoardDrawDataGetAction,
  BoardDrawDataCreateAction,
  BoardDrawDataUpdateAction,
  BoardElementListCopyAction,
  BoardElementListCopyForNowPageAction,
} from "./actions";
import {
  screenDataUpdate,
  screenDataUpdateError,
  usernameUpdate,
  usernameUpdateError,
  teacherUsernameSet,
  teacherUsernameSetError,
  //
  backgroundCategoryGetPending,
  backgroundCategoryGetError,
  backgroundCategoryGetSuccess,
  backgroundListGetPending,
  backgroundListGetError,
  backgroundListGetSuccess,
  userBackgroundListGetPending,
  userBackgroundListGetError,
  userBackgroundListGetSuccess,
  boardInfoGetError,
  boardInfoGetSuccess,
  boardLastPageError,
  boardLastPageSuccess,
  boardListGetPending,
  boardListGetError,
  boardListGetSuccess,
  boardPageCreateError,
  boardPageCreateSuccess,
  boardPageDeleteError,
  boardPageDeleteSuccess,
  boardPageCopyError,
  boardPageCopySuccess,
  imageListGetError,
  imageListGetSuccess,
  boardElementListGetError,
  boardElementListGetSuccess,
  boardElementCreateError,
  boardElementCreateSuccess,
  boardElementDeleteError,
  boardElementDeleteSuccess,
  memberListGetError,
  memberListGetSuccess,
  memberCreateError,
  memberCreateSuccess,
  cardListGetSuccess,
  cardListGetError,
  cardCreateError,
  cardCreateSuccess,
  workListGetSuccess,
  workCreateError,
  boardDarwDataGetError,
  boardDarwDataGetSuccess,
  boardDarwDataCreateError,
  boardDarwDataCreateSuccess,
  boardDarwDataUpdateError,
  boardDarwDataUpdateSuccess,
  //
  boardElementsCopySuccess,
  boardElementsCopyForNowPageSuccess,
} from "./slice";

import type {
  Screen,
  ScreenDataUpdateRequest,
  UsernameRequest,
  TeacherUsernameRequest,
  BackgroundListGetRequest,
  BackgroundListGetResponse,
  UserBackgroundListGetResponse,
  BoardInfo,
  BoardInfoGetRequest,
  BoardInfoGetResponse,
  BoardLastPageRequest,
  BoardLastPageResponse,
  BoardListGetRequest,
  BoardListGetResponse,
  BoardPageFormData,
  BoardPageDeleteFormData,
  ImageListGetRequest,
  ImageListGetResponse,
  BoardElementListGetRequest,
  BoardElementListGetResponse,
  BoardDrawDataGetRequest,
  BoardDrawDataGetResponse,
  BoardDrawDataCreateFormData,
  BoardDrawDataCreateResponse,
  BoardDrawDataUpdateFormData,
  ElementCreateFormData,
  ElementDeleteFormData,
  ElementGroupDeleteFormData,
  MemberListGetRequest,
  MemberListGetResponse,
  CreateMemberFormData,
  CardListGetRequest,
  CardListGetResponse,
  CreateCardFormData,
  BoardElementListCopyRequest,
} from "./types";

const API_URL = process.env.REACT_APP_API_URL;

function* executeScreenDataUpdate(data: {
  type?: string;
  payload: ScreenDataUpdateRequest;
}) {
  try {
    yield put(screenDataUpdate(data.payload as Screen));
  } catch (error: any) {
    yield put(screenDataUpdateError(error));
  }
}

function* executeUsernameUpdate() {
  try {
    const BoardId = getUrlParameter("board");
    const username = localStorage.getItem(`username-${BoardId}`);
    if (username) {
      yield put(usernameUpdate({
        username: username
      }));
    }
  } catch (error: any) {
    yield put(usernameUpdateError(error));
  }
}

function* executeTeacherUsernameSet(data: {
  type?: string;
  payload: TeacherUsernameRequest;
}) {
  try {
    console.log('data.payload', data.payload);

    yield put(teacherUsernameSet(data.payload));
  } catch (error: any) {
    yield put(teacherUsernameSetError(error));
  }
}

function* executeBackgroundCategoryGet() {
  try {
    yield put(backgroundCategoryGetPending());
    const response: AxiosResponse<BackgroundListGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/backgroundsCategory`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(backgroundCategoryGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(backgroundCategoryGetError("背景圖列表取得失敗"));
  }
}

function* executeBackgroundListGet(data: {
  type?: string;
  payload: BackgroundListGetRequest;
}) {
  try {
    yield put(backgroundListGetPending());
    const response: AxiosResponse<BackgroundListGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/backgrounds?category_id=${data.payload.category_id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(backgroundListGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(backgroundListGetError("背景圖列表取得失敗"));
  }
}

function* executeUserBackgroundListGet() {
  try {
    yield put(userBackgroundListGetPending());
    const response: AxiosResponse<UserBackgroundListGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/userBackgrounds`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(userBackgroundListGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(userBackgroundListGetError("背景圖列表取得失敗"));
  }
}

function* executeBoardInfoGet(data: {
  type?: string;
  payload: BoardInfoGetRequest;
}) {
  try {
    const response: AxiosResponse<BoardInfoGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/board/${data.payload.id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(boardInfoGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(boardInfoGetError("白板資訊取得失敗"));
  }
}

function* executeBoardLastPageSet(data: {
  type?: string;
  payload: BoardLastPageRequest;
}): Saga<void> {
  const { id, ...formData } = data.payload;
  try {
    const response: AxiosResponse<BoardLastPageResponse> = yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/nowPage/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(boardLastPageSuccess(response.data));
    }
  } catch (error: any) {
    yield put(boardLastPageError("頁面設定失敗"));
  }
}

function* executeBoardListGet(data: {
  type?: string;
  payload: BoardListGetRequest;
}): Saga<void> {
  const { id, pageNum, stop_socket, ...formData } = data.payload;
  try {
    yield put(boardListGetPending());
    const response: AxiosResponse<BoardListGetResponse> = yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/boardPages/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(boardListGetSuccess({...response.data, pageNum: pageNum, stop_socket: (stop_socket || false)}));
    }
  } catch (error: any) {
    yield put(boardListGetError("白板取得失敗"));
  }
}

function* executeBoardPageCreate(data: {
  type?: string;
  payload: BoardPageFormData;
}) {
  try {
    const { id, pageNum, is_deleted, ...formData } = data.payload;
    yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/createPages/${id}`,
    });
    yield put(boardPageCreateSuccess(null));
    yield call(
      executeBoardListGet,
      BoardListGetAction({
        id: id,
        pageNum: pageNum,
        is_deleted: is_deleted
      }),
    );
  } catch (error: any) {
    yield put(boardPageCreateError("頁面建立失敗"));
  }
}

function* executeBoardPageUpdate(data: {
  type?: string;
  payload: BoardPageFormData;
}) {
  try {
    const { id, board_id, pageNum, is_deleted, ...formData } = data.payload;
    yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/updatePages/${board_id}`,
    });
    yield put(boardPageCreateSuccess(null));
    yield call(
      executeBoardListGet,
      BoardListGetAction({
        id: id,
        pageNum: pageNum,
        is_deleted: is_deleted
      }),
    );
  } catch (error: any) {
    yield put(boardPageCreateError("頁面更新失敗"));
  }
}

function* executeBoardPageDelete(data: {
  type?: string;
  payload: BoardPageDeleteFormData;
}) {
  try {
    const { id, board_id, pageNum, is_deleted, ...formData } = data.payload;
    yield call(invokeAPI, {
      data: formData,
      method: "DELETE",
      url: `${API_URL}/api/deletePages/${board_id}`,
    });
    yield put(boardPageDeleteSuccess(null));
    yield call(
      executeBoardListGet,
      BoardListGetAction({
        id: id,
        pageNum: pageNum,
        is_deleted: is_deleted
      }),
    );
  } catch (error: any) {
    yield put(boardPageDeleteError("頁面刪除失敗"));
  }
}

function* executeBoardPageCopy(data: {
  type?: string;
  payload: BoardPageFormData;
}) {
  try {
    const { id, board_id, pageNum, is_deleted, ...formData } = data.payload;
    yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/copyPages/${board_id}`,
    });
    yield put(boardPageCopySuccess(null));
    yield call(
      executeBoardListGet,
      BoardListGetAction({
        id: id,
        pageNum: pageNum,
        is_deleted: is_deleted
      }),
    );
  } catch (error: any) {
    yield put(boardPageCopyError("頁面複製失敗"));
  }
}

function* executeBoardImageListGet(data: {
  type?: string;
  payload: ImageListGetRequest;
}): Saga<void> {
  const { id } = data.payload;
  try {
    const response: AxiosResponse<ImageListGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/boardImages/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(imageListGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(imageListGetError("圖片列表取得失敗"));
  }
}

function* executeBoardElementListGet(data: {
  type?: string;
  payload: BoardElementListGetRequest;
}): Saga<void> {
  const { id, ...formData } = data.payload;
  try {
    const response: AxiosResponse<BoardElementListGetResponse> = yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/boardElements/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(boardElementListGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(boardElementListGetError("網路連線不佳"));
  }
}

function* executeBoardElementDelete(data: {
  type?: string;
  payload: ElementDeleteFormData;
}) {
  try {
    const { id } = data.payload;
    yield call(invokeAPI, {
      data: {},
      method: "DELETE",
      url: `${API_URL}/api/deleteElements/${id}`,
    });
    yield put(boardElementDeleteSuccess(null));
  } catch (error: any) {
    yield put(boardElementDeleteError("元件刪除失敗"));
  }
}

function* executeBoardElementGroupDelete(data: {
  type?: string;
  payload: ElementGroupDeleteFormData;
}) {
  try {
    yield call(invokeAPI, {
      data: data.payload,
      method: "DELETE",
      url: `${API_URL}/api/deleteElementsList`,
    });
    yield put(boardElementDeleteSuccess(null));
  } catch (error: any) {
    yield put(boardElementDeleteError("元件刪除失敗"));
  }
}

function* executeMemberCreate(data: {
  type?: string;
  payload: CreateMemberFormData;
}) {
  try {
    yield call(invokeAPI, {
      data: data.payload,
      method: "POST",
      url: `${API_URL}/api/createBoardUsersData`,
    });
    yield put(memberCreateSuccess(null));
    yield call(
      executeMemberListGet,
      MemberListGetAction(),
    );
  } catch (error: any) {
    yield put(memberCreateError("名單建立失敗"));
  }
}

function* executeMemberListGet(data: {
  type?: string;
  payload: any;
}) {
  try {
    const response: AxiosResponse<MemberListGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/boardUsersData`,
    });
    if (response.data.status === "SUCCESS") {
      const list = response.data.data.map((item: any) => {
        item.name = item.name.split("(")[0];
        return item;
      });
      response.data.data = list;
      yield put(memberListGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(memberListGetError("名單列表取得失敗"));
  }
}

function* executeCardCreate(data: {
  type?: string;
  payload: CreateCardFormData;
}) {
  try {
    yield call(invokeAPI, {
      data: data.payload,
      method: "POST",
      url: `${API_URL}/api/createBoardCardsData`,
    });
    yield put(cardCreateSuccess(null));
    yield call(
      executeCardListGet,
      CardListGetAction(),
    );
  } catch (error: any) {
    yield put(cardCreateError("名單建立失敗"));
  }
}

function* executeCardListGet(data: {
  type?: string;
  payload: any;
}) {
  try {
    const response: AxiosResponse<CardListGetResponse> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/boardCardsData`,
    });
    if (response.data.status === "SUCCESS") {
      const list = response.data.data.map((item: any) => {
        item.name = item.name.split("(")[0];
        return item;
      });
      response.data.data = list;
      yield put(cardListGetSuccess(response.data));
    }
  } catch (error: any) {
    yield put(cardListGetError("卡片列表取得失敗"));
  }
}

function* executeWorkListGet(data: {
  type?: string;
  payload: any;
}) {
  try {
    const response: AxiosResponse<any> = yield call(invokeAPI, {
      method: "GET",
      url: `${API_URL}/api/works`,
    });
    yield put(workListGetSuccess(response.data.list));
  } catch (error: any) {
    yield put(workCreateError("作業取得失敗"));
  }
}

function* executeBoardDrawDataGet(data: {
  type?: string;
  payload: BoardDrawDataGetRequest;
}): Saga<void> {
  const { id } = data.payload;
  try {
    const response: AxiosResponse<BoardDrawDataGetResponse> = yield call(invokeAPI, {
      data: { is_deleted: false, is_draw: true },
      method: "POST",
      url: `${API_URL}/api/boardElements/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      const Draw_obj: any = {
        id: null,
        data: null
      };
      if (response.data.data.length !== 0) {
        Draw_obj['id'] = response.data.data[0].id;
        Draw_obj['data'] = response.data.data[0].content;
      } else {
        yield call(
          executeBoardDrawDataCreate,
          BoardDrawDataCreateAction({
            id: id,
            type: "BOARD_DRAW",
            content: JSON.stringify({ draw: "", teacherScreen: 0 })
          }),
        );
      }

      yield put(boardDarwDataGetSuccess(Draw_obj));
    }
  } catch (error: any) {
    yield put(boardDarwDataGetError("網路連線不佳"));
  }
}

function* executeBoardDrawDataCreate(data: {
  type?: string;
  payload: BoardDrawDataCreateFormData;
}) {
  const { id, ...formData } = data.payload;
  try {
    const response: AxiosResponse<BoardDrawDataCreateResponse> = yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/createElements/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      yield put(boardDarwDataCreateSuccess(response.data));
      yield call(
        executeBoardDrawDataGet,
        BoardDrawDataGetAction({ id: id }),
      );
    }
  } catch (error: any) {
    yield put(boardDarwDataCreateError("畫筆建立失敗"));
  }
}

function* executeBoardDrawDataUpdate(data: {
  type?: string;
  payload: BoardDrawDataUpdateFormData;
}) {
  try {
    const { id, ...formData } = data.payload;
    yield call(invokeAPI, {
      data: formData,
      method: "POST",
      url: `${API_URL}/api/updateElements/${id}`,
    });
    yield put(boardDarwDataUpdateSuccess(null));
    yield call(
      executeBoardDrawDataGet,
      BoardDrawDataGetAction({ id: id }),
    );
  } catch (error: any) {
    yield put(boardDarwDataUpdateError("畫筆更新失敗"));
  }
}

function* executeBoardElementListCopy(data: {
  type?: string;
  payload: BoardElementListCopyRequest;
}) {
  try {
    yield put(boardElementsCopySuccess(JSON.stringify(data.payload.elements)));
  } catch (error: any) {
    console.log('複製失敗');
  }
}

function* executeBoardElementListCopyForNowPage(data: {
  type?: string;
  payload: BoardElementListCopyRequest;
}) {
  try {
    yield put(boardElementsCopyForNowPageSuccess(JSON.stringify(data.payload.elements)));
  } catch (error: any) {
    console.log('複製失敗');
  }
}

function* userSaga() {
  yield takeEvery(ScreenDataUpdateAction, executeScreenDataUpdate);
  yield takeEvery(UsernameAction, executeUsernameUpdate);
  yield takeEvery(TeacherUsernameAction, executeTeacherUsernameSet);
  //
  yield takeEvery(BackgroundCategoryGetAction, executeBackgroundCategoryGet);
  yield takeEvery(BackgroundListGetAction, executeBackgroundListGet);
  yield takeEvery(UserBackgroundListGetAction, executeUserBackgroundListGet);
  yield takeEvery(BoardInfoGetAction, executeBoardInfoGet);
  yield takeEvery(BoardLastPageAction, executeBoardLastPageSet);
  yield takeEvery(BoardListGetAction, executeBoardListGet);
  yield takeEvery(BoardPageCreateAction, executeBoardPageCreate);
  yield takeEvery(BoardPageUpdateAction, executeBoardPageUpdate);
  yield takeEvery(BoardPageDeleteAction, executeBoardPageDelete);
  yield takeEvery(BoardPageCopyAction, executeBoardPageCopy);
  yield takeEvery(ImageListGetAction, executeBoardImageListGet);
  yield takeEvery(BoardElementListGetAction, executeBoardElementListGet);
  yield takeEvery(BoardElementDeleteAction, executeBoardElementDelete);
  yield takeEvery(BoardElementGroupDeleteAction, executeBoardElementGroupDelete);
  yield takeEvery(MemberCreateAction, executeMemberCreate);
  yield takeEvery(MemberListGetAction, executeMemberListGet);
  yield takeEvery(CardCreateAction, executeCardCreate);
  yield takeEvery(CardListGetAction, executeCardListGet);
  yield takeEvery(WorkListGetAction, executeWorkListGet);
  yield takeEvery(BoardDrawDataGetAction, executeBoardDrawDataGet);
  yield takeEvery(BoardDrawDataCreateAction, executeBoardDrawDataCreate);
  yield takeEvery(BoardDrawDataUpdateAction, executeBoardDrawDataUpdate);
  //
  yield takeEvery(BoardElementListCopyAction, executeBoardElementListCopy);
  yield takeEvery(BoardElementListCopyForNowPageAction, executeBoardElementListCopyForNowPage);
}

export default userSaga;
